/**
 * Convert null to undefined
 * The purpose of this function is to help with zod preprocessing,
 * where we want to treat null values as undefined, allowing
 * default values to be applied.
 */
export const setNullToUndefined = <T = unknown>(v: T) =>
  v === null ? undefined : v;
